// https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references
export const ENDASH = String.fromCharCode(8211);
export const EMDASH = String.fromCharCode(8212);
export const HELLIP = String.fromCharCode(8230);
export const NBSP = String.fromCharCode(160);
